import { createTheme, rem, MantineTheme } from '@mantine/core';


// Check out the list of variables you can use to customize your app
// https://mantine.dev/styles/css-variables-list/

export const theme = createTheme({
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  headings: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  },
  colors: {
    primary: [
      '#E6E6E6', // 0: Lightest
      '#CCCCCC', // 1
      '#999999', // 2
      '#666666', // 3
      '#404248', // 4: Hover
      '#333333', // 5
      '#1A1A1A', // 6
      '#0D0D0D', // 7
      '#000000', // 8: Primary
      '#000000', // 9: Darkest
    ],
    secondary: [
      '#E6FDF7', // 0: Lightest
      '#CCF9EE', // 1
      '#99F4DE', // 2
      '#66F0CD', // 3
      '#33EBBD', // 4
      '#10EFC7', // 5: Secondary
      '#0DBF9F', // 6
      '#098F77', // 7
      '#00614F', // 8: Tertiary
      '#003027', // 9: Darkest
    ],
    mainColor:  [
      "#000000", //black 
      "#efedff",
      "#dad6fd",
      "#b0aaf2",
      "#857be9",
      "#6053e1",
      "#493add",
      "#4334DC",
      "#2e20c4",
      "#261cb0",
      "#1c169c"
    ],
    // all hex values with a number beside them need to be replaced. Currently just adding demo values. 
    textColor: [
      "#FFFFFF",  // white
      "rgba(255, 255, 255, 0.7)", // transparent gray 
      "#333333",  // 2
      "#4d4d4d",  // 3
      "#666666",  // 4
      "#808080",  // 5
      "#999999",  // 6
      "#b3b3b3",  // 7
      "#cccccc",  // 8
      "#e6e6e6"   // 9
    ]
    // dark: [
    //   'var(--mantine-color-dark-0)',
    //   'var(--mantine-color-dark-1)',
    //   'var(--mantine-color-dark-2)',
    //   'var(--mantine-color-dark-3)',
    //   'var(--mantine-color-dark-4)',
    //   'var(--mantine-color-dark-5)',
    //   'var(--mantine-color-dark-6)',
    //   'var(--mantine-color-dark-7)',
    //   'var(--mantine-color-dark-8)',
    //   'var(--mantine-color-dark-9)',
    // ],
    // light: [
    //   'var(--mantine-color-gray-0)',
    //   'var(--mantine-color-gray-1)',
    //   'var(--mantine-color-gray-2)',
    //   'var(--mantine-color-gray-3)',
    //   'var(--mantine-color-gray-4)',
    //   'var(--mantine-color-gray-5)',
    //   'var(--mantine-color-gray-6)',
    //   'var(--mantine-color-gray-7)',
    //   'var(--mantine-color-gray-8)',
    //   'var(--mantine-color-gray-9)',
    // ],
  },
  primaryColor: 'primary',
  primaryShade: 8,
  defaultRadius: 'sm',
  components: {
    Button: {
      defaultProps: {
        color: 'primary',
        variant: 'filled',
      },
      styles: {
        root: (theme: MantineTheme) => ({
          '&[data-variant="outline"]': {
            color: '#CCCCCC',
            borderColor: '#666666',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              borderColor: '#CCCCCC',
              color: '#FFFFFF',
            },
          },
          '&[data-variant="filled"]': {
            backgroundColor: '#000000',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#404248',
            },
          },
        }),
      },
    },
    ActionIcon: {
      defaultProps: {
        color: 'primary',
      },
      styles: {
        root: (theme: MantineTheme) => ({
          '&[data-variant="outline"]': {
            color: theme.colors.red[3],
            borderColor: theme.colors.red[3],
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(255, 59, 48, 0.1)',
              borderColor: theme.colors.red[2],
              color: theme.colors.red[2],
            },
            '&:disabled': {
              color: theme.colors.gray[6],
              borderColor: theme.colors.gray[7],
              backgroundColor: 'transparent',
            },
          },
        }),
      },
    },
  },
  other: {
    '--mantine-breakpoint-xs': '36em',
    '--mantine-breakpoint-sm': '48em',
    '--mantine-breakpoint-md': '62em',
    '--mantine-breakpoint-lg': '75em',
    '--mantine-breakpoint-xl': '88em',
    '--mantine-spacing-xs': '0.625rem',
    '--mantine-spacing-sm': '0.75rem',
    '--mantine-spacing-md': '1rem',
    '--mantine-spacing-lg': '1.25rem',
    '--mantine-spacing-xl': '2rem',
    '--mantine-font-size-xs': '0.75rem',
    '--mantine-font-size-sm': '0.875rem',
    '--mantine-font-size-md': '1rem',
    '--mantine-font-size-lg': '1.125rem',
    '--mantine-font-size-xl': '1.25rem',
    '--mantine-line-height-xs': 1.4,
    '--mantine-line-height-sm': 1.45,
    '--mantine-line-height-md': 1.55,
    '--mantine-line-height-lg': 1.6,
    '--mantine-line-height-xl': 1.65,
    '--mantine-shadow-xs': '0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.1)',
    '--mantine-shadow-sm': '0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 0.625rem 0.9375rem -0.3125rem, rgba(0, 0, 0, 0.04) 0 0.4375rem 0.4375rem -0.3125rem',
    '--mantine-shadow-md': '0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 1.25rem 1.5625rem -0.3125rem, rgba(0, 0, 0, 0.04) 0 0.625rem 0.625rem -0.3125rem',
    '--mantine-shadow-lg': '0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 1.75rem 1.4375rem -0.4375rem, rgba(0, 0, 0, 0.04) 0 0.75rem 0.75rem -0.4375rem',
    '--mantine-shadow-xl': '0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 2.25rem 1.75rem -0.4375rem, rgba(0, 0, 0, 0.04) 0 1.0625rem 1.0625rem -0.4375rem',
    '--mantine-radius-xs': '0.125rem',
    '--mantine-radius-sm': '0.25rem',
    '--mantine-radius-md': '0.5rem',
    '--mantine-radius-lg': '1rem',
    '--mantine-radius-xl': '2rem',
    '--mantine-color-default-color': 'var(--mantine-color-black)',
    primaryColor: '#000000',
    primaryHoverColor: '#404248',
    secondaryColor: '#10EFC7',
    tertiaryColor: '#00614F',
  },
});

// You can continue to add custom colors here the you can add through variables
// You can also give them a light and dark variable through CSS Variables Resolver. See at the bottom of this link (https://mantine.dev/styles/css-variables/)
